<template>
  <div :class="$style.container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      :viewBox="`0 0 ${size} ${size}`"
      :width="size"
      :height="size"
    >
      <circle
        :cx="circleSize"
        :cy="circleSize"
        :r="circleSize"
        shape-rendering="geometricPrecision"
      ></circle>
      <circle
        :cx="circleSize"
        :cy="circleSize"
        :r="circleSize"
        shape-rendering="geometricPrecision"
      ></circle>
    </svg>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { prepareCssValue } from '@scripts/helpers/cssHelpers'

type CircleLoaderPropsType = {
  size?: number;
  thickness?: number;
  circleColor?: string;
  indicatorColor?: string;
  speed?: number;
  zIndex?: number;
}

const {
  size = 164,
  thickness = 12,
  circleColor = 'var(--color-primary-dark)',
  indicatorColor = 'var(--color-primary-light)',
  speed = 1.25,
  zIndex = 99
} = defineProps<CircleLoaderPropsType>()

const loaderSize = computed(() => prepareCssValue(size))
const loaderThickness = computed(() => thickness)
const loaderAnimationSpeed = computed(() => prepareCssValue(speed, 's'))

const circleSize = computed(() => (size - thickness) / 2)
const circleOffset = computed(() => prepareCssValue(thickness / 2))
</script>

<style lang="scss" module>
.container {
  @include size(v-bind(loaderSize));
  z-index: v-bind(zIndex);
}

svg {
  z-index: v-bind(zIndex);
  animation: loader-1 linear infinite;
  animation-duration: v-bind(loaderAnimationSpeed);
}

@keyframes loader-1 {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

svg circle {
  width: 100%;
  height: 100%;
  stroke: v-bind(circleColor);
  stroke-width: v-bind(loaderThickness);
  fill: none;
  transform: translate(v-bind(circleOffset), v-bind(circleOffset));
}

svg circle:nth-child(2) {
  stroke-linecap: round;
  stroke-dasharray: 70% 300%;
  stroke: v-bind(indicatorColor);
  transform-origin: center;
  animation: loader-2 cubic-bezier(0.770, 0.000, 0.175, 1.000) infinite;
  animation-duration: v-bind(loaderAnimationSpeed);
}

@keyframes loader-2 {
  0%   { transform: rotate(45deg) translate(v-bind(circleOffset), v-bind(circleOffset)); }
  100% { transform: rotate(405deg) translate(v-bind(circleOffset), v-bind(circleOffset)); }
}
</style>
